import { ModelSagres } from "@/types/model-sagres";
import { AtributoSerigy } from "./atributo-serigy";

export class CriterioSerigy extends ModelSagres {
    id: number
    criterioIdItem: string
    criterioDs: string
    atributos: AtributoSerigy[]

    // transientes
    temRespostaAuditor: boolean
    cpfAuditor: string | null
    dhResposta: string | null

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.id) this.id = obj.id
            if (obj.criterioIdItem) this.criterioIdItem = obj.criterioIdItem
            if (obj.criterioDs) this.criterioDs = obj.criterioDs
            if (obj.atributos) {
                this.atributos = obj.atributos.map(a => new AtributoSerigy(a))

                // transientes
                this.temRespostaAuditor = this.atributos.some((a) => a.temRespostaAuditor)
                if (this.temRespostaAuditor)
                    this.cpfAuditor = this.atributos.find((a) => a.cpfAuditor)?.cpfAuditor ?? null
            }
        }
    }
}